
import { Component, Mixins, Prop } from "vue-property-decorator";
import { FormatReference } from "../../../domain/format";
import { FormatValidatableMixin } from "../../../components/format/mixins";
import { IFormatTreeSourceFilterable, QuotableFormatFilter } from "../../format/selectors/trees/sources";

@Component
export default class NewDocumentFormatSelectDispatchMixin extends Mixins(FormatValidatableMixin) {
  @Prop()
  quotedDocumentId: number;

  @Prop()
  defaultFormatId: number;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  formatIds: number[];

  @Prop()
  formatName: string;

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  institutionNo: string;

  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  problemNo: string;

  @Prop({ default: false })
  shouldCloseOnRegistered: boolean;

  @Prop()
  defaultToolTabName: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop({ default: false })
  shouldInheritFormat: boolean;

  @Prop()
  validateObjectValuesUrl: string;

  @Prop()
  getObjectValuesUrl: string;

  @Prop()
  isQuoted: boolean;

  data(): any {
    return {
      selectedItem: null as FormatReference,
    };
  }
  selectedItem: FormatReference;

  get formatId(): number {
    return this.defaultFormatId
      ? this.defaultFormatId
      : null;
  }

  public toString<T>(value: T): string {
    return value !== undefined
      ? value.toString()
      : "";
  }

  async isValidFormat(format: FormatReference): Promise<boolean> {
    const result = await this.validateFormat(format, false); // 直接記載としてチェックする
    return result;
  }

  get formatTreeSourceFilter(): IFormatTreeSourceFilterable {
    // 相澤病院以外ではフィルター不要
    const isFormatFilterEnable = this.$configuration.behavior.document.editor.quotation.formatFilter.isEnable;
    return (!!this.quotedDocumentId && isFinite(this.quotedDocumentId) && isFormatFilterEnable)
      ? new QuotableFormatFilter(this.quotedDocumentId)
      : null;
  }
}
